/* eslint-disable react/forbid-prop-types */
import React from "react";
import PropTypes from "prop-types";
import ListPoint from "./ListPoint";
import Description from "./Description";

function Table({ tableHeadings, tableData }) {
	return (
		<div className="table-container">
			<table className="table-responsive">
				<tr>
					{tableHeadings?.map((item) => (
						<th>{item}</th>
					))}
				</tr>
				{tableData?.map((data) => (
					<tr>
						<td>
							{data?.ROW_1?.customPoint && (
								<ListPoint {...data.ROW_1.customPoint} />
							)}

							{data?.ROW_1?.points?.map((point) => (
								<ListPoint desc={point} />
							))}
							<br />
							{data.ROW_1.paragraph && (
								<Description desc={data.ROW_1.paragraph} />
							)}
						</td>
						<td>
							{data.ROW_2?.map((content) => (
								<Description desc={content} />
							))}
						</td>
						<td>
							{data.ROW_3?.map((content) => (
								<>
									<Description desc={content} />
									<br />
								</>
							))}
						</td>
						<td>
							{data.ROW_4?.map((content) => (
								<>
									<Description desc={content} />
									<br />
								</>
							))}
						</td>
					</tr>
				))}
			</table>
		</div>
	);
}

Table.propTypes = {
	tableHeadings: PropTypes.array,
	tableData: PropTypes.array
};

export default Table;
